// extracted by mini-css-extract-plugin
export default {"DayOrderDisplay":"DayOrderDisplay_DayOrderDisplay__cfMAT"};